import { InspectHCF, programTypePage } from './pages'
import {
  healthcareAllegation,
  healthcareProgram,
  hhsEmployeeType
} from '../../../choices'
import {
  allegationPage,
  commonPageSequence,
  employeePage,
  employeeTypePage,
  programPage,
  retaliatedAgainstPage,
  reviewPage
} from '../../../pages'

export const formSchema = saveComplaint => {
  const initialPages = [
    allegationPage({ choices: healthcareAllegation() }),
    programPage({ choices: healthcareProgram() }),
    programTypePage()
  ]
  const finalPages = [
    employeePage({
      gotoPageYes: 'employee_type_page',
      gotoPageNo: 'review_page'
    }),
    employeeTypePage({ choices: hhsEmployeeType() }),
    retaliatedAgainstPage(),
    reviewPage(InspectHCF)
  ]

  return {
    title: 'Healthcare Fraud Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: initialPages.concat(
      commonPageSequence({ includeVictim: false }),
      finalPages
    )
  }
}
